/** DOM attribute names used by help mode. */
export const ATTR = {
    element: 'data-help',
    section: 'data-help-section',
    page: 'data-help-page',
    why: 'data-help-why',
    ui: 'data-help-ui',
    /** On an element: a mouse click explains the element itself, not its section (dashboard tiles, action items). */
    solo: 'data-help-solo',
} as const;

/**
 * Spread helper for a tag whose key is looked up at run time. The key-coverage scan only reads literal
 * attributes, so the literal keys live in maps (components/dashboard/board/helpKeys.ts) and the
 * computed property name here keeps this helper itself out of that scan.
 */
export const helpElement = (key?: string): Record<string, string> => (key ? { [ATTR.element]: key } : {});
